import React, { useCallback, useEffect, useRef, useState } from 'react';
import { focusManager } from '@accedo/vdkweb-navigation';
import { FocusButton, FocusDiv } from '@accedo/vdkweb-tv-ui';
import './privacy-policy.component.scss';
import BackArrow from '../../assets/images/back-arrow.svg';
import { getPageBackId } from '../../redux/selector/xdk.store';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const subscriberAgreementTabNav = {
  id: 'subscriber-agreement-tab',
  nextdown: 'privacy-policy-tab',
};
const privacyPolicyTabNav = {
  id: 'privacy-policy-tab',
  nextup: 'subscriber-agreement-tab',
  nextdown: 'your-privacy-choices-tab',
  //nextright: 'content-pane', //uncomment once the full privacy policy can be fetched
};
const yourPrivacyChoicesTabNav = {
  id: 'your-privacy-choices-tab',
  nextup: 'privacy-policy-tab',
  nextdown: 'back-button',
};
const backButtonNav = {
  id: 'back-button',
  nextup: 'your-privacy-choices-tab',
};
const contentPaneNav = {
  id: 'content-pane',
  nextleft: 'privacy-policy-tab',
};
const tabTheme = {
  button: 'tab',
  buttonFocused: 'tab-focused',
  buttonActive: 'tab-active',
};
const backButtonTheme = {
  button: 'back-button',
  buttonFocused: 'back-button-focused',
  buttonActive: 'back-button-active',
};

export const PrivacyPolicyScreen = () => {
  const [contentPaneData, setContentPaneData] = useState({
    title: '',
    body: '',
    style: { overflowY: 'scroll' as any },
  });
  const [contentPaneIsFocused, setContentPaneIsFocused] = useState(false);

  useEffect(() => {
    focusManager.changeFocus(subscriberAgreementTabNav.id);
  }, []);

  const contentPaneRef = useRef(null);
  const scrollContent = useCallback(event => {
    if (event.keyCode === 38) {
      contentPaneRef.current.scrollBy(0, -100);
    } else if (event.keyCode === 40) {
      contentPaneRef.current.scrollBy(0, 100);
    }
  }, []);

  useEffect(() => {
    return () => window.removeEventListener('keydown', scrollContent, true);
  }, []);

  useEffect(() => {
    contentPaneRef.current.scrollTo(0, 0);
  }, [contentPaneData.title]);

  /* Handles the back button press logic - START */
  const isMounted = useRef(false);
  const history = useHistory();
  const backId = useSelector(getPageBackId);
  useEffect(() => {
    if (isMounted.current) {
      if (contentPaneIsFocused) {
        focusManager.changeFocus(privacyPolicyTabNav.id);
      } else {
        history.goBack();
      }
    } else {
      isMounted.current = true;
    }
  }, [backId]);
  /* Handles the back button press logic - END */

  return (
    <div className="privacy-policy-screen-container">
      <div className="privacy-policy-screen-title">
        Policies &amp; Agreements
      </div>
      <div className="privacy-policy-screen-content-container">
        <div className="privacy-policy-screen-tabs">
          <FocusButton
            theme={tabTheme}
            nav={subscriberAgreementTabNav}
            onFocus={() => {
              setContentPaneData({
                title: 'Customer Agreement',
                body:
                  'To view the customer agreement, please visit:\n\nsiriusxm.com/customeragreement',
                style: { overflowY: 'hidden' as any },
              });
            }}
          >
            Customer Agreement
          </FocusButton>
          <FocusButton
            theme={tabTheme}
            nav={privacyPolicyTabNav}
            onClick={() => {
              //focusManager.changeFocus(contentPaneNav.id); //Uncomment once full privacy policy can be fetched again
            }}
            onFocus={() => {
              setContentPaneData({
                title: 'Privacy Policy',
                body:
                  'To view the privacy policy, please visit:\n\nsiriusxm.com/privacy',
                style: { overflowY: 'hidden' as any }, //change to overflowY: 'scroll' when full privacy policy can be fetched
              });
            }}
          >
            Privacy Policy
          </FocusButton>
          <FocusButton
            theme={tabTheme}
            nav={yourPrivacyChoicesTabNav}
            onFocus={() => {
              setContentPaneData({
                title: 'Your Privacy Choices',
                body:
                  'To view your privacy choices, please visit:\n\nsiriusxm.com/yourprivacychoices',
                style: { overflowY: 'hidden' as any },
              });
            }}
          >
            Your Privacy Choices
          </FocusButton>
          <FocusButton
            theme={backButtonTheme}
            nav={backButtonNav}
            onClick={() => {
              history.goBack();
            }}
          >
            <img src={BackArrow} />
            <span>Back</span>
          </FocusButton>
        </div>
        <div
          className={`privacy-policy-screen-content ${
            contentPaneIsFocused ? 'focused' : ''
          }`}
          style={contentPaneData.style}
          ref={contentPaneRef}
        >
          <FocusDiv
            nav={contentPaneNav}
            className="content-pane"
            onFocus={() => {
              setContentPaneIsFocused(true);
              window.addEventListener('keydown', scrollContent);
            }}
            onBlur={() => {
              setContentPaneIsFocused(false);
              window.removeEventListener('keydown', scrollContent);
            }}
          >
            <div className="content-pane-title-text">
              {contentPaneData.title}
            </div>
            <div className="content-pane-body">{contentPaneData.body}</div>
          </FocusDiv>
        </div>
      </div>
    </div>
  );
};
